export default __webpack_public_path__ + "assets/docs/Privacy_Policy_Forly_Capital_ru.pdf";